export default __webpack_public_path__ + "static/customer-service-mb-e73ce3d01104d0b2f0c6dd367c67bd91.png";